// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1B5QE","container":"styles_container__3TJqN","title":"styles_title__2SE0L","wrapper":"styles_wrapper__2Rf8k","answer":"styles_answer__Tz24H"};